import React, { useEffect } from "react";

// import OpeningIntro from "./Home/MainSlider.jsx";
// import Product from "./Extra/Product";
import ExploreEthiccraft from "./Home/Explore_Ethiccraft";
// import RecentEvents from "./Extra/RecentEvents";
import Testimonials from "./Home/Testimonials_old";
import Ourreach from "./Home/Ourreach";
import Leaders from "./Home/Leaders";
import UpcomingEvents from "./Home/Upcoming_Events";
import SpiritofCelebration from "./Home/SpiritofCelebration";
import OurCauses from "./Home/Our_Causes";

import "./Css/Homepage.css";
import Banner from "./Home/MainSlider";


function Home() {
  useEffect(() => {
    // ScrollReveal was here, removed to favor AOS/Framer Motion
  }, []);

  return (
    <div>
      <Banner />
      {/* <PhotoCollage /> */}
      <UpcomingEvents />
      <Ourreach />
      <ExploreEthiccraft />
      <OurCauses />
      <Leaders />
      <SpiritofCelebration />
      <Testimonials />
    </div>
  );
}

export default Home;
